import { afterNextRender, Directive, ElementRef, inject } from '@angular/core';
import { Rellax as TypeRellax } from 'rellax';

declare let Rellax: TypeRellax;

@Directive({
  selector: '[parallax]',
  standalone: true,
})
export class ParallaxDirective {
  private el = inject(ElementRef);

  constructor() {
    afterNextRender(() => {
      new Rellax(this.el.nativeElement as HTMLElement);
    });
  }
}
